/**
 * SAP Integration Service
 * Handles all SAP-related API calls
 */

import api from './api';

class SAPService {
  // ==================== Dashboard Stats ====================
  async getDashboardStats() {
    const response = await api.get('/sap/operations/dashboard-stats/');
    return response.data;
  }

  // ==================== Purchase Orders ====================
  async getPurchaseOrders(params = {}) {
    const response = await api.get('/sap/purchase-orders/', { params });
    return response.data;
  }

  async getPurchaseOrderById(id) {
    const response = await api.get(`/sap/purchase-orders/${id}/`);
    return response.data;
  }

  async syncPurchaseOrders(data) {
    const response = await api.post('/sap/operations/sync-purchase-orders/', data);
    return response.data;
  }

  // ==================== Material Documents ====================
  async getMaterialDocuments(params = {}) {
    const response = await api.get('/sap/material-documents/', { params });
    return response.data;
  }

  async getMaterialDocumentById(id) {
    const response = await api.get(`/sap/material-documents/${id}/`);
    return response.data;
  }

  // ==================== QC Rules ====================
  async getQCRules(params = {}) {
    const response = await api.get('/sap/qc-rules/', { params });
    return response.data;
  }

  async getQCRuleById(id) {
    const response = await api.get(`/sap/qc-rules/${id}/`);
    return response.data;
  }

  async syncQCRule(materialCode, configName = 'default') {
    const response = await api.post('/sap/operations/sync-qc-rule/', {
      material_code: materialCode,
      config_name: configName
    });
    return response.data;
  }

  // ==================== Inventory ====================
  async getInventorySnapshots(params = {}) {
    const response = await api.get('/sap/inventory/', { params });
    return response.data;
  }

  async getInventorySnapshotById(id) {
    const response = await api.get(`/sap/inventory/${id}/`);
    return response.data;
  }

  async syncInventory(data) {
    const response = await api.post('/sap/operations/sync-inventory/', data);
    return response.data;
  }

  // ==================== GRN Operations ====================
  async postGRN(grnId, configName = 'default') {
    const response = await api.post('/sap/operations/post-grn/', {
      grn_id: grnId,
      config_name: configName
    });
    return response.data;
  }

  async createReturn(grnId, reason, configName = 'default') {
    const response = await api.post('/sap/operations/create-return/', {
      grn_id: grnId,
      reason: reason,
      config_name: configName
    });
    return response.data;
  }

  // Mock Post GRN - for demo purposes (synchronous, no task queue)
  async mockPostGRN(grnId) {
    const response = await api.post('/sap/operations/mock-post-grn/', {
      grn_id: grnId
    });
    return response.data;
  }

  // ==================== Request Logs ====================
  async getRequestLogs(params = {}) {
    const response = await api.get('/sap/logs/', { params });
    return response.data;
  }

  async getRequestLogById(id) {
    const response = await api.get(`/sap/logs/${id}/`);
    return response.data;
  }

  // ==================== Connection Configs ====================
  async getConfigs(params = {}) {
    const response = await api.get('/sap/configs/', { params });
    return response.data;
  }

  async getConfigById(id) {
    const response = await api.get(`/sap/configs/${id}/`);
    return response.data;
  }

  async createConfig(data) {
    const response = await api.post('/sap/configs/', data);
    return response.data;
  }

  async updateConfig(id, data) {
    const response = await api.put(`/sap/configs/${id}/`, data);
    return response.data;
  }

  async deleteConfig(id) {
    const response = await api.delete(`/sap/configs/${id}/`);
    return response.data;
  }
}

export const sapService = new SAPService();
export default sapService;
